/**
 * Subscription Tiers Block - Frontend JavaScript
 * Handles Stripe checkout for subscription buttons
 */

(function() {
	'use strict';

	// Wait for DOM to be ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	function init() {
		const blocks = document.querySelectorAll('.wp-block-xtra-subscription-tiers');

		blocks.forEach(block => {
			const stripeKey = block.dataset.stripeKey;
			const returnUrl = block.dataset.returnUrl || window.location.href;

			// Skip if Stripe not configured
			if (!stripeKey) {
				console.warn('Stripe not configured for subscription tiers block');
				return;
			}

			// Handle button clicks
			const buttons = block.querySelectorAll('.xtra-tier-button[data-stripe-price-id]');
			buttons.forEach(button => {
				button.addEventListener('click', async (e) => {
					e.preventDefault();

					// Prevent double clicks
					if (button.classList.contains('loading')) {
						return;
					}

					const priceId = button.dataset.stripePriceId;
					const tierName = button.dataset.tierName || 'Subscription';

					if (!priceId) {
						console.error('No Stripe price ID found');
						return;
					}

					// Show loading state
					button.classList.add('loading');
					button.disabled = true;
					const originalText = button.textContent;

					try {
						// Create checkout session via REST API
						const response = await fetch(xtraSubscriptionTiers.apiUrl, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'X-WP-Nonce': xtraSubscriptionTiers.nonce
							},
							body: JSON.stringify({
								price_id: priceId,
								mode: 'subscription',
								success_url: returnUrl + (returnUrl.includes('?') ? '&' : '?') + 'subscription=success',
								cancel_url: window.location.href
							})
						});

						const data = await response.json();

						if (response.ok && data.url) {
							// Redirect to Stripe checkout
							window.location.href = data.url;
						} else {
							throw new Error(data.message || 'Failed to create checkout session');
						}

					} catch (error) {
						console.error('Checkout error:', error);

						// Show error to user
						alert('Unable to start checkout: ' + error.message);

						// Reset button state
						button.classList.remove('loading');
						button.disabled = false;
						button.textContent = originalText;
					}
				});
			});
		});
	}

	// Check if returning from successful checkout
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.get('subscription') === 'success') {
		// Show success message
		const message = document.createElement('div');
		message.className = 'xtra-subscription-success';
		message.style.cssText = 'background: #10b981; color: white; padding: 1rem; margin: 1rem 0; text-align: center;';
		message.innerHTML = '✓ Subscription successful! Welcome to your new membership tier.';

		// Insert at top of first subscription block if exists
		const firstBlock = document.querySelector('.wp-block-xtra-subscription-tiers');
		if (firstBlock) {
			firstBlock.parentNode.insertBefore(message, firstBlock);
		}

		// Remove the parameter from URL without refresh
		const cleanUrl = window.location.href.split('?')[0];
		window.history.replaceState({}, document.title, cleanUrl);
	}
})();